<template>
  <article>
    <!--바로가기 navi-->
    <div id="accNav">
      <router-link to="#content">본문 바로가기</router-link>
      <router-link to="#footer">푸터 바로가기</router-link>
    </div>

    <!-- mobile -->
    <header id="mobile">
      <div class="inner">
        <div class="top">
          <h1 class="logo">
            <router-link to="/Main">
              <div class="logoImg"></div>
              통합주차포털
            </router-link>
          </h1>
          <button type="button" @click="menubtn" class="moTopMenu"><span class="hidden">메뉴</span></button>
        </div>
      </div>
      <gnb-mobile v-show="btnmenu" @closeResult="closeResult"></gnb-mobile>
    </header>

    <!-- pc -->
    <header id="web">
      <!--top-->
      <div class="top">
        <div class="inner">
          <h1 class="logo">
            <router-link to="/Main">
              <div class="logoImg"></div>
              통합주차포털
            </router-link>
          </h1>
          <div class="rightArea">
            <article class="utill">
              <!-- Logout -->
              <ul v-if="isLogin">
                <li class="welcome">
                  <span>{{ empNm }}</span> 님
                </li>
                <li>
                  <span class="logout btn" @click="actionLogout">로그아웃</span>
                </li>
                <li>
                  <router-link to="/mypagemain" class="mint" title="회원정보">회원정보</router-link>
                </li>
              </ul>

              <!-- Login -->
              <ul v-else>
                <li>
                  <router-link to="/loginmain" class="dkblue" title="로그인">로그인</router-link>
                </li>
                <li>
                  <router-link to="/join" class="mint" title="회원가입">회원가입</router-link>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </div>
      <!--//top-->

      <!--bottom-->
      <div class="bottom">
        <div class="inner">
          <button class="siteMapBtn" @click="siteMapBtn"><span class="hidden">사이트맵</span></button>
          <!--sitemap-->
          <div class="siteMap" v-if="modalShow" @emitHideModal="modalShow = false">
            <div class="stieMapBox">
              <div class="inner">
                <div class="siteMapHead">
                  <p>전체메뉴</p>
                </div>
                <div class="siteMapCont">
                  <div class="row">
                    <div class="column">
                      <div class="menuArea">
                        <router-link to="/map" title="공영주차장">공영주차장</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li>
                            <router-link to="/map" title="노외주차장 검색">노외주차장 검색</router-link>
                            <ul>
                              <li><router-link to="/map" title="지도검색">지도검색</router-link></li>
                              <li><router-link to="/list" title="주소검색">주소검색</router-link></li>
                            </ul>
                          </li>
                          <li>
                            <router-link to="/parkfeeinformation" title="주차장 이용안내">주차장 이용안내</router-link>
                          </li>
                          <li>
                            <router-link to="/parkfeereduction" title="주차요금 감면안내"
                              >주차요금 감면안내</router-link
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="column">
                      <div class="menuArea">
                        <router-link to="/unpaidinfo" title="주차요금 정산">주차요금 정산</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li>
                            <router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link>
                            <ul>
                              <li>
                                <router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link>
                              </li>
                              <li><router-link to="/lookup" title="요금조회/결제">요금조회/결제</router-link></li>
                              <!--<li>
                                <router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link>
                              </li> -->
                            </ul>
                          </li>
                          <li>
                            <router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link>
                            <ul>
                              <li>
                                <router-link to="/unpaidinfo" title="미납요금 납부안내">미납요금 납부안내</router-link>
                              </li>
                              <li>
                                <router-link to="/lookupunpaid" title="미납요금 조회/결제"
                                  >미납요금 조회/결제</router-link
                                >
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="column">
                      <div class="menuArea">
                        <router-link to="/periodinfo" title="주차서비스">주차서비스</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li v-if="!isBusiness || idAdmin">
                            <router-link to="/periodinfo" title="정기권">정기권</router-link>
                            <ul>
                              <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
                              <li>
                                <router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link>
                              </li>
                              <li>
                                <router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link>
                              </li>
                            </ul>
                          </li>
                          <span v-else></span>
                          <li v-if="isBusiness || !isLogin || idAdmin">
                            <router-link to="/webdiscountuse" title="웹 선불권">웹 선불권</router-link>
                            <ul>
                              <li>
                                <router-link to="/webdiscountcharge" title="웹 선불권 충전">웹 선불권 충전</router-link>
                              </li>
                              <li><router-link to="/webdiscountuse" title="웹 선불권 적용">웹 선불권 적용</router-link></li>
                            </ul>
                          </li>
                          <span v-else></span>
                        </ul>
                      </div>
                    </div>
                    <div class="column">
                      <div class="menuArea">
                        <router-link to="/noticelist" title="정보마당">정보마당</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
                          <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
                          <li><router-link to="/qnalist" title="묻고답하기">묻고답하기</router-link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="isLogin">
                    <div class="column">
                      <div class="menuArea">
                        <router-link to="/mypagemain" title="마이페이지">마이페이지</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li><router-link to="/mypagemain" title="회원정보">회원정보</router-link></li>
                          <li v-if="!isBusiness || idAdmin">
                            <router-link to="/mypageprepayment" title="서비스 이용내역">서비스 이용내역</router-link>
                          </li>
                          <li v-if="isBusiness || idAdmin">
                            <router-link to="/mypagediscountpayment" title="웹 선불권 이용내역"
                              >웹 선불권 이용내역</router-link
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="column" v-if="idAdmin">
                      <div class="menuArea">
                        <router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li>
                            <router-link to="/generalmembership" title="회원관리">회원관리</router-link>
                            <ul>
                              <li><router-link to="/generalmembership" title="일반회원">일반회원</router-link></li>
                              <li><router-link to="/businessmembership" title="사업자회원">사업자회원</router-link></li>
                            </ul>
                          </li>
                          <li>
                            <router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link>
                            <ul>
                              <li>
                                <router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link>
                              </li>
                              <li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
                            </ul>
                          </li>
                          <li>
                            <router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="column" v-if="idAdmin">
                      <div class="menuArea">
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide" style="margin-top: 40px">
                          <li>
                            <router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link>
                            <ul>
                              <li>
                                <router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link>
                              </li>
                              <li>
                                <router-link to="/faqmanagement" title="자주묻는질문 관리"
                                  >자주묻는질문 관리</router-link
                                >
                              </li>
                            </ul>
                          </li>
                          <li>
                            <router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link>
                            <ul>
                              <li><router-link to="/popuplist" title="팝업관리">팝업관리</router-link></li>
                              <li><router-link to="/bannerlist" title="배너관리">배너관리</router-link></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="column" v-if="idAdmin">
                      <div class="menuArea">
                        <router-link to="/usermanagement" title="시스템관리">시스템관리</router-link>
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide">
                          <li>
                            <router-link to="/usermanagement" title="사용자관리">사용자관리</router-link>
                          </li>
                          <li>
                            <router-link to="/teamlist" title="팀관리">팀관리</router-link>
                          </li>
                          <li>
                            <router-link to="/departmentlist" title="부서관리">부서관리</router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="column" v-if="idAdmin">
                      <div class="menuArea">
                        <ul class="menu" @click="modalHide" @keydown.enter="modalHide" style="margin-top: 40px">
                          <li>
                            <router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link>
                          </li>
                          <li>
                            <router-link to="/accessinfo" title="접속정보">접속정보</router-link>
                          </li>
                          <!-- <li>
                            <router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link>
                          </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="sitemapClose"
                  @click="modalHide"
                  @keydown.enter="modalHide"
                  data-focus-next="next"
                >
                  <span class="hidden">닫기</span>
                </button>
              </div>
            </div>
            <div class="overay"></div>
          </div>

          <!--gnb-->
          <nav class="gnb" @mouseover="over" @mouseleave="leave" @keydown.tab="over" @keydown.enter="leave">
            <ul class="depth01">
              <li>
                <router-link to="/map" title="공영주차장" @click.native="leave">공영주차장</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li>
                      <router-link to="/map" title="주노외주차장 검색" @click.native="leave">노외주차장 검색</router-link>
                      <ul class="depth03">
                        <li><router-link to="/map" title="지도검색" @click.native="leave">지도검색</router-link></li>
                        <li><router-link to="/list" title="주소검색" @click.native="leave">주소검색</router-link></li>
                      </ul>
                    </li>
                    <li>
                      <router-link to="/parkfeeinformation" title="주차장 이용안내" @click.native="leave">주차장 이용안내</router-link>
                    </li>
                    <li>
                      <router-link to="/parkfeereduction" title="주차요금 감면안내" @click.native="leave">주차요금 감면안내</router-link>
                    </li>
                  </ul>
                </article>
              </li>
              <li>
                <router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li><router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link></li>
                    <li><router-link to="/lookup" title="요금 조회/결제">요금 조회/결제</router-link></li>
                    <!-- <li>
                      <router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link>
                    </li> -->
                  </ul>
                </article>
              </li>
              <li>
                <router-link to="/unpaidinfo" title="미납주차요금" @click.native="leave">미납주차요금</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li><router-link to="/unpaidinfo" title="미납요금 납부안내" @click.native="leave">미납요금 납부안내</router-link></li>
                    <li>
                      <router-link to="/lookupunpaid" title="미납요금 조회/결제" @click.native="leave">미납요금 조회/결제</router-link
                      >
                    </li>
                  </ul>
                </article>
              </li>
              <li>
                <router-link to="/periodinfo" title="주차서비스" @click.native="leave">주차서비스</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li v-if="!isBusiness || idAdmin">
                      <router-link to="/periodinfo" title="정기권" @click.native="leave">정기권</router-link>
                      <ul class="depth03">
                        <li><router-link to="/periodinfo" title="정기권 안내" @click.native="leave">정기권 안내</router-link></li>
                        <li><router-link to="/periodapplication" title="정기권 신청" @click.native="leave">정기권 신청</router-link></li>
                        <li><router-link to="/periodlookup" title="정기권 조회/결제" @click.native="leave">정기권 조회/결제</router-link></li>
                      </ul>
                    </li>
                    <span v-else></span>
                    <li v-if="isBusiness || !isLogin || idAdmin">
                      <router-link to="/webdiscountuse" title="웹 선불권" @click.native="leave">웹 선불권</router-link>
                      <ul class="depth03">
                        <li><router-link to="/webdiscountcharge" title="웹 선불권 충전" @click.native="leave">웹 선불권 충전</router-link></li>
                        <li><router-link to="/webdiscountuse" title="웹 선불권 적용" @click.native="leave">웹 선불권 적용</router-link></li>
                      </ul>
                    </li>
                    <span v-else></span>
                  </ul>
                </article>
              </li>
              <li>
                <router-link to="/noticelist" title="정보마당" @click.native="leave">정보마당</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li>
                      <router-link to="/noticelist" title="공지사항" @click.native="leave">공지사항</router-link>
                    </li>
                    <li>
                      <router-link to="/faqview" title="자주묻는질문" @click.native="leave">자주묻는질문</router-link>
                    </li>
                    <li>
                      <router-link to="/qnalist" title="묻고 답하기" @click.native="leave">묻고 답하기</router-link>
                    </li>
                  </ul>
                </article>
              </li>
              <li v-if="isLogin">
                <router-link to="/mypagemain" title="마이페이지" @click.native="leave">마이페이지</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li>
                      <router-link to="/mypagemain" title="회원정보" @click.native="leave">회원정보</router-link>
                    </li>
                    <li v-if="!isBusiness || idAdmin">
                      <router-link to="/mypageprepayment" title="서비스 이용내역" @click.native="leave">서비스 이용내역</router-link>
                    </li>
                    <li v-if="isBusiness || idAdmin">
                      <router-link to="/mypagediscountpayment" title="웹 선불권 이용내역 " @click.native="leave">웹 선불권 이용내역</router-link>
                    </li>
                  </ul>
                </article>
              </li>
              <li v-if="idAdmin">
                <router-link to="/generalmembership" title="관리자메뉴" @click.native="leave">관리자메뉴</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li>
                      <router-link to="/generalmembership" title="회원관리" @click.native="leave">회원관리</router-link>
                      <ul class="depth03">
                        <li><router-link to="/generalmembership" title="일반회원" @click.native="leave">일반회원</router-link></li>
                        <li><router-link to="/businessmembership" title="사업자회원" @click.native="leave">사업자회원</router-link></li>
                      </ul>
                    </li>
                    <li>
                      <router-link to="/discountvehicle" title="할인차량관리" @click.native="leave">할인차량관리</router-link>
                      <ul class="depth03">
                        <li><router-link to="/discountvehicle" title="할인차량 관리" @click.native="leave">할인차량 관리</router-link></li>
                        <li><router-link to="/freevehicle" title="무료차량 관리" @click.native="leave">무료차량 관리</router-link></li>
                      </ul>
                    </li>
                    <li>
                      <router-link to="/periodparking" title="정기권 주차장관리" @click.native="leave">정기권 주차장관리</router-link>
                    </li>
                    <li>
                      <router-link to="/noticemanagement" title="게시판관리" @click.native="leave">게시판관리</router-link>
                      <ul class="depth03">
                        <li><router-link to="/noticemanagement" title="공지사항 관리" @click.native="leave">공지사항 관리</router-link></li>
                        <li>
                          <router-link to="/faqmanagement" title="자주묻는질문 관리" @click.native="leave">자주묻는질문 관리</router-link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <router-link to="/popuplist" title="팝업/배너관리" @click.native="leave">팝업/배너관리</router-link>
                      <ul class="depth03">
                        <li><router-link to="/popuplist" title="팝업관리" @click.native="leave">팝업관리</router-link></li>
                        <li><router-link to="/bannerlist" title="배너관리" @click.native="leave">배너관리</router-link></li>
                      </ul>
                    </li>
                  </ul>
                </article>
              </li>
              <li v-if="idAdmin">
                <router-link to="/usermanagement" title="시스템관리" @click.native="leave">시스템관리</router-link>
                <article v-show="active">
                  <ul class="depth02">
                    <li>
                      <router-link to="/usermanagement" title="사용자관리" @click.native="leave">사용자관리</router-link>
                    </li>
                    <li>
                      <router-link to="/teamlist" title="팀관리" @click.native="leave">팀관리</router-link>
                    </li>
                    <li>
                      <router-link to="/departmentlist" title="부서관리" @click.native="leave">부서관리</router-link>
                    </li>
                    <li>
                      <router-link to="/menulist" title="메뉴관리" @click.native="leave">메뉴관리</router-link>
                    </li>
                    <li>
                      <router-link to="/userauthoritylist" title="사용자권한관리" @click.native="leave">사용자권한관리</router-link>
                    </li>
                    <li>
                      <router-link to="/accessinfo" title="접속정보" @click.native="leave">접속정보</router-link>
                    </li>
                    <!-- <li @keyup.tab="leave">
                      <router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link>
                    </li> -->
                  </ul>
                </article>
              </li>
            </ul>
            <div class="gnbBg" v-show="active"></div>
          </nav>
          <!--//gnb-->

          <article class="quickMenu" :class="{ isActive }" @click="isActive = !isActive">
            <p>Quick Menu</p>
            <div class="menuList">
              <ul>
                <li>
                  <router-link to="/map">
                    <i class="icon q-map"></i>
                    <span>주차장<br />지도검색</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/lookup">
                    <i class="icon q-prepay"></i>
                    <span>주차요금<br />사전결제</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/lookupunpaid">
                    <i class="icon q-unpaid"></i>
                    <span>미납<br />주차요금</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/periodinfo">
                    <i class="icon q-period"></i>
                    <span>정기권<br />신청</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/qnalist">
                    <i class="icon q-qna"></i>
                    <span>묻고<br />답하기</span>
                  </router-link>
                </li>
                <!-- <li>
                  <router-link to="/advancepayment">
                    <i class="icon q-fee"></i>
                    <span>주차요금<br />간편조회</span>
                  </router-link>
                </li> -->
                </ul>
            </div>
            <button type="button" class="Qarrow"><span class="hidden">토글버튼</span></button>
          </article>
        </div>
      </div>
      <!--//bottom-->
    </header>
  </article>
</template>

<script>
import axios from 'axios';
import GnbMobile from './GnbMobile.vue';

export default {
  data() {
    return {
      active: false,
      isActive: false,
      modalShow: false,
      btnmenu: false,
      webDiscount: true,
    };
  },

  components: {
    GnbMobile,
  },

  methods: {
    over() {
      this.active = true;
    },
    leave() {
      this.active = false;
    },
    siteMapBtn() {
      this.modalShow = true;
    },
    modalHide() {
      this.modalShow = false;
    },
    menubtn() {
      this.btnmenu = !this.btnmenu;
    },
    closeResult() {
      this.btnmenu = false;
    },

    actionLogout() {
      axios
        .post('/api/actionLogout.json')
        .then(response => {
          alert('로그아웃 하였습니다.');
          this.$store.dispatch('logout', null);
          this.$router.push('/loginmain');
        })
        .catch(function (error) {});
    },
  },

  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    isBusiness() {
      return this.$store.state.empDiv === 'BSN';
    },
    idAdmin() {
      return this.$store.state.authorCode === 'ROLE_ADMIN';
    },
    empNm() {
      return this.$store.state.empNm;
    },
  },
};
</script>
